






















































import { Vue, Component } from 'vue-property-decorator'
import {
    DEFAULT_NETWORK_ID,
    cChainExplorerURL,
    cChainExplorerURL_test,
    statusURL,
    statusURL_test,
} from '@/store/modules/network/network'

@Component({})
export default class Footer extends Vue {
    get cChainURL() {
        return DEFAULT_NETWORK_ID === 1
            ? cChainExplorerURL
            : cChainExplorerURL_test
    }

    get statusPageURL() {
        return DEFAULT_NETWORK_ID === 1 ? statusURL : statusURL_test
    }

    get img() {
        const color = DEFAULT_NETWORK_ID === 1 ? `black` : `blue`
        return `/img/ava_logo_${color}.png`
    }
}
